import * as allRoutes from './routes';
export const routes = allRoutes;